import React from 'react';


const AddButton = ({ addClick, add }) => {
    return (
        <div className='ba tc dt ma1 pa1 w-100 f4-ns f3 dim pointer noselect shadow-1 grow bg-dark-gray light-blue br3' onClick={addClick}>{add ? '-' : '+'}</div>
    )
}

export default AddButton;